export function createFetchError(statusCode, message) {
    return {
        statusCode,
        message,
    };
}
export function getData(url, onSuccess, onError, variables = {}, options) {
    const defaultOptions = {
        dataType: "json",
    };
    const mergedOptions = { ...defaultOptions, ...options };
    const headers = {};
    if (mergedOptions.bearerToken) {
        headers["Authorization"] = `Bearer ${mergedOptions.bearerToken}`;
    }
    if (mergedOptions.apiKey) {
        headers["x-api-key"] = mergedOptions.apiKey;
    }
    const params = new URLSearchParams(variables).toString();
    const fetchUrl = params ? `${url}${url.includes("?") ? "&" : "?"}${params}` : url;
    fetch(fetchUrl, {
        method: "GET",
        headers: headers,
        credentials: mergedOptions.withCredentials ? "include" : undefined,
    })
        .then((response) => {
        if (response.ok) {
            const promise = mergedOptions.dataType === "json" ? response.json() : response.text();
            promise.then((data) => {
                if (mergedOptions.dataType === "xml") {
                    data = new DOMParser().parseFromString(data, "application/xml");
                }
                onSuccess(data, response.status);
            });
        }
        else {
            onError(createFetchError(response.status, response.statusText));
        }
    })
        .catch((error) => {
        // Handle network errors (e.g., DNS resolution failed, connection refused)
        onError(createFetchError(0, error.message));
    });
}
export function getWFSData(url, variables, username, password, onSuccess, onError, options) {
    const defaultOptions = {
        dataType: "json",
    };
    const mergedOptions = { ...defaultOptions, ...options };
    const headers = {
        "Content-Type": "xml/text", // Mimicking jQuery behavior, though unusual for GET
    };
    if (username && password) {
        headers["Authorization"] = "Basic " + btoa(username + ":" + password);
    }
    const params = new URLSearchParams(variables).toString();
    const fetchUrl = params ? `${url}${url.includes("?") ? "&" : "?"}${params}` : url;
    fetch(fetchUrl, {
        method: "GET",
        headers: headers,
        credentials: mergedOptions.withCredentials ? "include" : undefined,
    })
        .then((response) => {
        if (response.ok) {
            const promise = mergedOptions.dataType === "json" ? response.json() : response.text();
            promise.then((data) => {
                if (mergedOptions.dataType === "xml") {
                    data = new DOMParser().parseFromString(data, "application/xml");
                }
                onSuccess(data, response.status);
            });
        }
        else {
            onError(createFetchError(response.status, response.statusText));
        }
    })
        .catch((error) => {
        onError(createFetchError(0, error.message));
    });
}
export function postWFSDataSerialized(url, payload, username, password, onSuccess, onError, options) {
    const defaultOptions = {
        dataType: "json",
    };
    const mergedOptions = { ...defaultOptions, ...options };
    const payload_ = new XMLSerializer().serializeToString(payload);
    const headers = {
        "Content-Type": "xml/text",
    };
    if (username && password) {
        headers["Authorization"] = "Basic " + btoa(username + ":" + password);
    }
    fetch(url, {
        method: "POST",
        headers: headers,
        body: payload_,
        credentials: mergedOptions.withCredentials ? "include" : undefined,
    })
        .then((response) => {
        if (response.ok) {
            const promise = mergedOptions.dataType === "json" ? response.json() : response.text();
            promise.then((data) => {
                if (mergedOptions.dataType === "xml") {
                    data = new DOMParser().parseFromString(data, "application/xml");
                }
                onSuccess(data, response.status);
            });
        }
        else {
            onError(createFetchError(response.status, response.statusText));
        }
    })
        .catch((error) => {
        onError(createFetchError(0, error.message));
    });
}
export function postData(url, payload, onSuccess, onError, options) {
    const defaultOptions = {
        dataType: "json",
    };
    const mergedOptions = { ...defaultOptions, ...options };
    const headers = {};
    if (mergedOptions.contentType) {
        headers["Content-Type"] = mergedOptions.contentType;
    }
    else {
        // Fetch requires a content type for POST if payload is string/json,
        // but if payload is FormData or URLSearchParams, it sets it automatically.
        // jQuery does some auto-detection.
        // Assuming typical usage where payload is object for application/x-www-form-urlencoded
        // unless specified otherwise.
        headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
    }
    if (mergedOptions.bearerToken) {
        headers["Authorization"] = `Bearer ${mergedOptions.bearerToken}`;
    }
    if (mergedOptions.apiKey) {
        headers["x-api-key"] = mergedOptions.apiKey;
    }
    // jQuery's 'data' parameter in $.ajax handles object conversion to query string
    // for default content type. Fetch needs explicit body handling.
    let body;
    if (payload instanceof FormData || payload instanceof URLSearchParams) {
        body = payload;
        // Let the browser set Content-Type for FormData (multipart)
        delete headers["Content-Type"];
    }
    else if (typeof payload === "object" && headers["Content-Type"].includes("application/json")) {
        body = JSON.stringify(payload);
    }
    else if (typeof payload === "object") {
        body = new URLSearchParams(payload).toString();
    }
    else {
        body = payload;
    }
    fetch(url, {
        method: "POST",
        headers: headers,
        body: body,
        credentials: mergedOptions.withCredentials ? "include" : undefined,
    })
        .then((response) => {
        if (response.ok) {
            const promise = mergedOptions.dataType === "json" ? response.json() : response.text();
            promise.then((data) => {
                if (mergedOptions.dataType === "xml") {
                    data = new DOMParser().parseFromString(data, "application/xml");
                }
                onSuccess(data, response.status);
            });
        }
        else {
            onError(createFetchError(response.status, response.statusText));
        }
    })
        .catch((error) => {
        onError(createFetchError(0, error.message));
    });
}
// REVIEW: This seems should be named postData.
export function postDataSerialized(url, payload, onSuccess, onError, options) {
    const defaultOptions = {
        dataType: "json",
        contentType: "application/json",
    };
    const mergedOptions = { ...defaultOptions, ...options };
    const serializedPayload = JSON.stringify(payload);
    const headers = {};
    if (mergedOptions.contentType) {
        headers["Content-Type"] = mergedOptions.contentType;
    }
    if (mergedOptions.bearerToken) {
        headers["Authorization"] = `Bearer ${mergedOptions.bearerToken}`;
    }
    if (mergedOptions.apiKey) {
        headers["x-api-key"] = mergedOptions.apiKey;
    }
    fetch(url, {
        method: "POST",
        headers: headers,
        body: serializedPayload,
        credentials: mergedOptions.withCredentials ? "include" : undefined,
    })
        .then((response) => {
        if (response.ok) {
            const promise = mergedOptions.dataType === "json" ? response.json() : response.text();
            promise.then((data) => {
                if (mergedOptions.dataType === "xml") {
                    data = new DOMParser().parseFromString(data, "application/xml");
                }
                onSuccess(data, response.status);
            });
        }
        else {
            onError(createFetchError(response.status, response.statusText));
        }
    })
        .catch((error) => {
        onError(createFetchError(0, error.message));
    });
}
export function deleteData(url, onSuccess, onError, options) {
    const defaultOptions = {
        dataType: "json",
    };
    const mergedOptions = { ...defaultOptions, ...options };
    const headers = {};
    if (mergedOptions.bearerToken) {
        headers["Authorization"] = `Bearer ${mergedOptions.bearerToken}`;
    }
    if (mergedOptions.apiKey) {
        headers["x-api-key"] = mergedOptions.apiKey;
    }
    fetch(url, {
        method: "DELETE",
        headers: headers,
        credentials: mergedOptions.withCredentials ? "include" : undefined,
    })
        .then((response) => {
        if (response.ok) {
            const promise = mergedOptions.dataType === "json" ? response.json() : response.text();
            promise.then((data) => {
                if (mergedOptions.dataType === "xml") {
                    data = new DOMParser().parseFromString(data, "application/xml");
                }
                onSuccess(data, response.status);
            });
        }
        else {
            onError(createFetchError(response.status, response.statusText));
        }
    })
        .catch((error) => {
        onError(createFetchError(0, error.message));
    });
}
//# sourceMappingURL=ajax.js.map